import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=4f4b964d&"
import script from "./FeedbackList.vue?vue&type=script&lang=js&"
export * from "./FeedbackList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/plenty/Desktop/work/feedback-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4b964d')) {
      api.createRecord('4f4b964d', component.options)
    } else {
      api.reload('4f4b964d', component.options)
    }
    module.hot.accept("./FeedbackList.vue?vue&type=template&id=4f4b964d&", function () {
      api.rerender('4f4b964d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/singleitem/FeedbackList.vue"
export default component.exports